import { Box, Stack, TextField, Typography, useTheme } from '@mui/material';
import React from 'react';

type InputFieldProps = {
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  error?: boolean;
  rows?: number;
  multiline?: boolean;
  width?: number | string;
};

export default function FormField({
  label,
  value,
  onChange,
  disabled = false,
  error = false,
  rows = 1,
  multiline = false,
  width,
}: InputFieldProps) {
  const theme = useTheme();

  const textFieldWidth = React.useMemo(() => {
    if (!width) return 'none';
    if (typeof width === 'number') return theme.spacing(width);
    return width;
  }, [width, theme]);

  return (
    <Box sx={{ mt: 1 }}>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ width: '100%', display: 'flex' }}>
        {label && (
          <Typography variant="fieldHeader" width={theme.spacing(15)}>
            {label}
          </Typography>
        )}
        <TextField
          sx={{
            width: textFieldWidth,
            flexGrow: 1,
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
          size="small"
          value={value}
          onChange={onChange}
          disabled={disabled}
          error={error}
          multiline={multiline}
          rows={rows}
        />
      </Stack>
    </Box>
  );
}
